import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4958999f&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4958999f&prod&lang=scss"
import style1 from "./Footer.vue?vue&type=style&index=1&id=4958999f&prod&lang=scss&scoped=true"
import style2 from "./Footer.vue?vue&type=style&index=2&id=4958999f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4958999f",
  null
  
)

export default component.exports